<div v-if="getIsTooltipsActive" class="matrix_tooltipContainer">
  <appAwesomeIcon icon="info-circle" useClass="fa fa-info-circle"  v-if="getContent && !getIsMobile" v-tooltip.bottom-top="getTriggerEvent(getContent)"></appAwesomeIcon>
  <appAwesomeIcon icon="info-circle" useClass="fa fa-info-circle"  v-if="getContent && getIsMobile" v-tooltip.left="getTriggerEvent(getContent)" ></appAwesomeIcon>  
</div>
